import type { components } from '@pba/types-openapi-client';
import type { Entity } from './entity';
import { type Image, createImage } from './image';
import { type Preview, createPreview } from './preview';

export type GroupPreviewType = 'organization' | GroupType;

export type GroupSlim = {
  groupType: GroupType;
  logo?: Image;
} & Entity;

export type GroupType = components['schemas']['GroupTypeEnum'];

export const createGroupSlim = (data: components['schemas']['GroupSlim']): GroupSlim => ({
  groupType: data.group_type,
  id: data.id,
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  logo: data.logo ? createImage(data.logo) : undefined,
  name: data.name,
});

export type GroupBase = {
  coverPhoto?: Image;
  membersCount: number;
} & GroupSlim;

export const createGroupBase = (data: components['schemas']['GroupBase']): GroupBase => ({
  // eslint-disable-next-line @typescript-eslint/no-misused-spread -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  ...createGroupSlim(data),
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  coverPhoto: data.cover_photo ? createImage(data.cover_photo) : undefined,
  membersCount: data.members_count,
});

export type GroupDetail = {
  htmlDescription: string;
  preview: Preview[];
  settings: {
    allowPosts?: boolean;
  };
  textDescription: string;
} & GroupExtended;

export type GroupExtended = {
  ancestors: GroupBase[];
} & GroupBase;

export const createGroupExtended = (data: components['schemas']['GroupExtended']): GroupExtended => ({
  // eslint-disable-next-line @typescript-eslint/no-misused-spread -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  ...createGroupBase(data),
  ancestors: data.ancestors.map((ancestor) => createGroupBase(ancestor)),
});

export const createGroupDetail = (data: components['schemas']['GroupDetail']): GroupDetail => ({
  // eslint-disable-next-line @typescript-eslint/no-misused-spread -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  ...createGroupExtended(data),
  htmlDescription: data.html_description,
  preview: data.preview.map((group) => createPreview(group)),
  settings: {
    allowPosts: data.settings.allow_posts,
  },
  textDescription: data.text_description,
});
